import { render, staticRenderFns } from "./OrderDetailSummary.vue?vue&type=template&id=e7385a10&"
import script from "./OrderDetailSummary.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailSummary.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailSummary.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports